import { apiReducer } from 'utils/API'
import { USER_MESSAGE } from '../constants'

export default apiReducer({
  entity: USER_MESSAGE
})
